import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SubLedgerReportPayGatePaymentRequest {
  @observable
  cardNumber?: string;

  @observable
  variableSymbol?: number;

  @observable
  authCode?: string;

  @observable
  arn?: string;
}

export const SubLedgerReportPayGatePaymentRequestValidationRules: EntityValidationRules<SubLedgerReportPayGatePaymentRequest> = {
  cardNumber: {
    isLength: {
      min: 8,
      max: 24,
      optional: true,
    },
  },
  variableSymbol: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  authCode: {
    isLength: {
      max: 10,
      optional: true,
    },
  },
  arn: {
    isLength: {
      max: 30,
      optional: true,
    },
  },
};
